import { type Editor } from '@tiptap/react';
import { useEffect } from 'react';

import { requestWorkspaceAgentSkillMonikerCatalogUpgrade } from '~/components/v2/components/workspace/workspace-agent-panel/slash-commands/workspaceAgentSkillSuggestion';
import { type Skill } from '~/hooks/queries/skills/usePrivateSkillsList';

type UseWorkspaceAgentSkillMonikerCatalogUpgradeSyncParams = {
  editor: Editor | null;
  isSlashSkillsEnabled: () => boolean;
  skills: readonly Skill[];
};

/** Rehydrates skill monikers that only carry `skillId` after paste once `Skills.list` is available. */
export const useWorkspaceAgentSkillMonikerCatalogUpgradeSync = ({
  editor,
  isSlashSkillsEnabled,
  skills,
}: UseWorkspaceAgentSkillMonikerCatalogUpgradeSyncParams): void => {
  useEffect(() => {
    if (!editor || editor.isDestroyed || !isSlashSkillsEnabled() || skills.length === 0) {
      return;
    }

    requestWorkspaceAgentSkillMonikerCatalogUpgrade(editor);
  }, [editor, isSlashSkillsEnabled, skills]);
};
